import Navbar from "../components/Navbar";

export default function AboutMe(){
    return(
        <>
            <Navbar/>
            <a>test</a>
        </>
    )
}